import { InlineBoldParagraph } from "components/atoms/Typography";
import { DeleteButton } from "components/molecules/DangerousButtons";
import { useDeleteBuildingModels } from "mutations/useDeleteBuildingModels";
import posthog from "posthog-js";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";

interface DeleteBuildingProps {
    buildingModelUid: string;
    buildingName: string;
}

function DeleteBuilding({ buildingModelUid, buildingName }: DeleteBuildingProps) {
    const navigate = useNavigate();

    const onSuccess = () => navigate("/portfolio");

    const { mutate: deleteBuilding } = useDeleteBuildingModels(onSuccess);
    const options = useMemo(() => buildOptions(buildingName), [buildingName]);

    return (
        <DeleteButton
            onClick={() => {
                deleteBuilding([buildingModelUid]);
                posthog.capture("Buildings deleted", {
                    added_buildings_count: -1,
                });
            }}
            options={options}
        />
    );
}

const buildOptions = (buildingName: string) => ({
    popup: {
        buttonText: "Delete building",
    },
    modal: {
        title: "Delete building?",
        body: (
            <>
                This will <InlineBoldParagraph>permanently remove {buildingName} building</InlineBoldParagraph>. Do you
                wish to proceed?
            </>
        ),
        deleteButtonText: "Delete building",
        id: "delete-building-modal",
    },
});

export default DeleteBuilding;
